<template>
	<div>
		<div class="table-box" ref="scroll" >
			<!-- 表头 -->
			<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
				<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<template v-for="(item,index) in rableTitle" name="item.type">
						<div v-if="index <= sticky_index && item.show_control && item.type == 'date_key'" class="table-th-cell"
						:style="{'width':rableTitle[index].width + 'px'}" @click="sortClick(0)">
							{{rableTitle[index].title}}
							<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
								<a-icon type="caret-up" :style="{'color': rableTitle[0].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
								<a-icon type="caret-down" :style="{'color': rableTitle[0].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
							</div>
						</div>
						<div v-else-if="index <= sticky_index && item.show_control" class="table-th-cell" style="cursor: default;"
						:style="{'width':rableTitle[index].width + 'px'}" >
							{{rableTitle[index].title}}
						</div>
					</template>
					
					<!-- <div v-if="rableTitle[0].show_control && rableTitle[0].type==='date_key'" class="table-th-cell"
					:style="{'width':rableTitle[0].width + 'px'}" 
					@click="sortClick(0)">
						投放日期
						<div style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': rableTitle[0].sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': rableTitle[0].sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div>
					</div>
					<div v-if="rableTitle[1].show_control && rableTitle[1].type==='op_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[1].width + 'px'}" 
					>
						投手
					</div>
					<div v-if="rableTitle[2].show_control && rableTitle[2].type==='book_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[2].width + 'px'}" 
					>
						投放作品
					</div>
					<div v-if="rableTitle[3].show_control && rableTitle[3].type==='book_type'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[3].width + 'px'}" 
					>
						作品类型
					</div>
					<div v-if="rableTitle[4].show_control && rableTitle[4].type==='platform_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[4].width + 'px'}" 
					>
						媒体平台
					</div>
					<div v-if="rableTitle[5].show_control && rableTitle[5].type==='media_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[5].width + 'px'}" 
					>
						媒体版位
					</div>
					<div v-if="rableTitle[6].show_control && rableTitle[6].type==='channel_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[6].width + 'px'}" 
					>
						书城
					</div>
					<div v-if="rableTitle[7].show_control && rableTitle[7].type==='gzh_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[7].width + 'px'}" 
					>
						公众号/点众渠道号
					</div>
					<div v-if="rableTitle[8].show_control && rableTitle[8].type==='group_name'" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[8].width + 'px'}" 
					>
						投放小组
					</div> -->
				</div>
				
				<div  v-for="(item,index) in rableTitle" :key="index" >

					<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
					:style="{'width':item.width + 'px','justify-content': item.text_right?'flex-end':''}"
					
					@click="sortClick(index)">
						{{item.title}}
						<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div>
					</div>
				</div>
				<!-- 占位，隔出一个空白区域 -->
				<div id="" style="padding:15px;"></div>
			</div>
			
			<!-- 总计 -->
			<div v-if="tableShowData.length > 0" >
				<div class="table-td" :style="{'width': table_scroll_width + 'px'}">
					<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
						<template v-for="(z_tem,z_ndex) in rableTitle">
							<div v-if="z_ndex <= sticky_index && z_tem.show_control && z_ndex == 0" class="table-td-cell"
							:style="{'width':rableTitle[z_ndex].width + 'px'}">
								总计
							</div>
							<div v-else-if="z_ndex <= sticky_index && z_tem.show_control" class="table-td-cell"
							:style="{'width':rableTitle[z_ndex].width + 'px'}">
								
							</div>
						</template>
						<!-- <div  v-for="(item,index) in tableTotalData" :key="index + 100" style="display: flex;align-items: center;">
							<div v-if="index <= sticky_index && item.show_control && index == 0" class="table-td-cell"
							:style="{'width':item.widths + 'px'}"  :class="{'text-right': item.text_right}">
								总计
							</div>
							<div v-else-if="index <= sticky_index && item.show_control && index > 0" class="table-td-cell"
							:style="{'width':item.widths + 'px'}"  :class="{'text-right': item.text_right}">
								1
							</div>
						</div> -->
					</div>
					
					<!-- <div v-for="(item,index) in tableTotalData" :key="index" >
						<div v-if="index > sticky_index && item.show_control" class="table-td-cell"
						:style="{'width':item.widths + 'px'}"  :class="{'text-right': item.text_right}">
							{{item.value}}
						</div>
					</div> -->
					<template v-for="(z_tem,z_ndex) in rableTitle">
						<div v-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) < 0" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							{{tableTotalData[z_tem.type] || 0}}
						</div>
						<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							
						</div>
						<!-- <div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							{{tableSumData[z_tem.type]*100 | tableToFixed}}%
						</div>
						<div v-else-if="z_ndex > sticky_index && z_tem.show_control && x_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							{{tableSumData[z_tem.type] | tableToFixed}}
						</div> -->
					</template>
				</div>
				<!-- <div class="table-td-cell">
					{{tableTotalData.used_money}}
				</div> -->
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<!-- 星期/周维度下的时间跟其他的不一样，要做区分 -->
					<!-- <div  v-for="(item_s,index_s) in item" :key="index_s + 1000" style="display: flex;align-items: center;">
						<div v-if="item_s.show_control && item_s.keys === 'date_key'" class="table-td-cell"  :class="{'text-right': item_s.text_right}"
						:style="{'width':item_s.widths + 'px'}">
							{{date_type_control === 'week'?item_s.value.format_date:item_s.value}}
						</div>
						<div v-else-if="item_s.show_control && (item_s.keys === 'op_name' || item_s.keys === 'book_name' || item_s.keys === 'book_type' || item_s.keys === 'platform_name' || item_s.keys === 'media_name' || item_s.keys === 'channel_name' || item_s.keys === 'gzh_name' || item_s.keys === 'group_name')" class="table-td-cell"
						:style="{'width':item_s.widths + 'px'}"  :class="{'text-right': item_s.text_right}">
							{{item_s.value}}
						</div>
						
					</div> -->
					
					<template v-for="(z_tem,z_ndex) in rableTitle">
						<div v-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type == 'date_key'" class="table-td-cell" :class="{'text-right': z_tem.text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<!-- {{item[z_tem.type]}} -->
							{{date_type_control === 'week'?item[z_tem.type].format_date : item[z_tem.type]}}
						</div>
						<div v-else-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type == 'content_type' " class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							{{item[z_tem.type] | qdTypeFilters}}
						</div>
						<div v-else-if="z_ndex <= sticky_index && z_tem.show_control " class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							{{item[z_tem.type]}}
						</div>
						
					</template>
				</div>
				<!-- <div v-for="(item_z,index_z) in item" :key="index_z" :class="{'table-td-cell-sticky':index_z === 0}">
					<div v-if="item_z.show_control && (item_z.keys !== 'date_key' && item_z.keys !== 'op_name' && item_z.keys !== 'book_name' && item_z.keys !== 'book_type' && item_z.keys !== 'platform_name' && item_z.keys !== 'media_name' && item_z.keys !== 'channel_name' && item_z.keys !== 'gzh_name' && item_z.keys !== 'group_name')" class="table-td-cell"  :class="{'text-right': item_z.text_right}" :style="{'width':item_z.widths + 'px'}">
						
						<div v-if="item_z.keys == 'pay_user_num' || item_z.keys == 'sub_num' || item_z.keys == 'today_pay_user_num'">{{item_z.value}}</div>
						<div v-else>{{item_z.value | tableToFixed}}</div>
					</div>
				</div> -->
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<!-- <div>{{z_tem.type}}</div> -->
					<div v-if="z_ndex > sticky_index && z_tem.show_control && y_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type] || 0}}
					</div>
					
					<div v-else-if="z_ndex > sticky_index && z_tem.show_control" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type] | tableToFixed}}
					</div>
				</template>
				
			</div>
			
			<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: rgb(240, 242, 245);height: calc(100vh - 65px);width: 20px;"></div>
			<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: rgb(240, 242, 245);height: calc(100vh - 65px);width: 20px;"></div>
			
		</div>
	</div>
</template>

<script>
export default {
	name: 'TableShowB_',
	props: ['rableTitle','tableShowData','tableTotalData','table_scroll_width','date_type_control'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			sticky_index: 10,
			// 用于总计的不显示控制
			z_table_control: ['date_key','content_type','channel_name','gzh_name','book_name','book_type','platform_name','media_name','op_name','group_name','applets_name'],
		
			// 表格项不进行任何处理直接展示的-一般为文字内容
			y_table_control: ['pay_user_num','sub_num','today_pay_user_num'],
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index])
			if(index !== this.select_sort_index){
				this.select_sort_index = index
				that.rableTitle.forEach(res=>{
					res.sort_status = 0
				})
				that.rableTitle[index].sort_status = 1
				th_status = 1
			}
			else { // 点击的是同一个表头
				if(that.rableTitle[index].sort_status === 0){
					that.rableTitle[index].sort_status = 1 // 箭头向下
					th_status = 1
				}
				else if(that.rableTitle[index].sort_status === 1){
					that.rableTitle[index].sort_status = 2 // 箭头向上
					th_status = 2
				}
				else if(that.rableTitle[index].sort_status === 2){
					that.rableTitle[index].sort_status = 0
					th_status = 0
				}
			}
			
			let r_type
			if(that.rableTitle[index].type === 'op_name'){ // 投手
				r_type = 'op_id'
			}
			else if(that.rableTitle[index].type === "book_name"){ // 投放作品
				r_type = 'put_book'
			}
			else if(that.rableTitle[index].type === "platform_name"){ // 媒体平台
				r_type = 'type'
			}
			else if(that.rableTitle[index].type === "media_name"){ // 媒体版位
				r_type = 'media_id'
			}
			else if(that.rableTitle[index].type === "channel_name"){ // 书城
				r_type = 'channel_id'
			}
			else if(that.rableTitle[index].type === "gzh_name"){ // 公众号/点众渠道号
				r_type = 'gzh_id'
			}
			else if(that.rableTitle[index].title === "ROI_前7天"){ 
				r_type = 'recent_left_money_roi_before_7'
			}
			else if(that.rableTitle[index].title === "ROI_前6天"){ 
				r_type = 'recent_left_money_roi_before_6'
			}
			else if(that.rableTitle[index].title === "ROI_前5天"){ 
				r_type = 'recent_left_money_roi_before_5'
			}
			else if(that.rableTitle[index].title === "ROI_前4天"){ 
				r_type = 'recent_left_money_roi_before_4'
			}
			else if(that.rableTitle[index].title === "ROI_前3天"){ 
				r_type = 'recent_left_money_roi_before_3'
			}
			else if(that.rableTitle[index].title === "ROI_前2天"){ 
				r_type = 'recent_left_money_roi_before_2'
			}
			else if(that.rableTitle[index].title === "ROI_前1天"){ 
				r_type = 'recent_left_money_roi_before_1'
			}
			else if(that.rableTitle[index].title === "分成金额_前7天"){
				r_type = 'recent_left_money_before_7'
			}
			else if(that.rableTitle[index].title === "分成金额_前6天"){
				r_type = 'recent_left_money_before_6'
			}
			else if(that.rableTitle[index].title === "分成金额_前5天"){
				r_type = 'recent_left_money_before_5'
			}
			else if(that.rableTitle[index].title === "分成金额_前4天"){
				r_type = 'recent_left_money_before_4'
			}
			else if(that.rableTitle[index].title === "分成金额_前3天"){
				r_type = 'recent_left_money_before_3'
			}
			else if(that.rableTitle[index].title === "分成金额_前2天"){
				r_type = 'recent_left_money_before_2'
			}
			else if(that.rableTitle[index].title === "分成金额_前1天"){
				r_type = 'recent_left_money_before_1'
			}
			else {
				r_type = that.rableTitle[index].type
			}
			
			this.$emit('table-th-click', index, th_status, r_type)
		}
	},
	filters: {
		tableToFixed(value){
			// console.log("过滤器",value)
			let v = Number(value) || 0
			return v.toFixed(2)
		},
		qdTypeFilters(value){
			
			let v = ""
			if(value == 1){
				v = "H5书城"
			}
			else if(value == 2){
				v = "快应用书城"
			}
			else if(value == 3){
				v = "短剧"
			}
			return v
		}
	}
}
</script>

<style scoped>
	.table-box {
		position: relative;
		width: 100%;
		overflow-x: visible;
	}
	.table-th {
		position:sticky;
		top: 65px;
		z-index:3;
		display: flex;
		align-items: center;
	}
	.table-th-cell {
		display: flex;
		align-items: center;
		padding: 12px 8px;
		cursor: pointer;
		color: #060606;
		flex-shrink: 0;
		background-color: #fbfbfb;
		/* border-bottom: 1px solid #e8e8e8; */
		user-select: none;
		font-size: 13px;
	}
	.table-th-cell:hover {
		background-color: #eee;
	}
	.table-th-cell:hover .table-th-cell-sticky{
		background-color: #eee;
	}
	
	.table-td {
		
		display: flex;
		align-items: center;
		width: 100%;
		border-bottom: 1px solid #e8e8e8;
	}
	.table-td:hover {
		background-color: #eff9ff;
	}
	.table-td:hover .table-td-cell-sticky{
		background-color: #eff9ff;
	}
	.table-td-cell {
		padding: 10px 8px;
		flex-shrink: 0;
		cursor: default;
		word-break: break-all;
		color: rgba(0, 0, 0, 0.65);
		min-height: 40px;
		font-size: 12px;
		/* overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis; */
	}
	.table-td-cell-sticky {
		position: sticky;
		left: 20px;
		z-index: 2;
		background-color: #fff;
	}
	.table-th-cell-sticky {
		position: sticky;
		left: 20px;
		z-index: 2;
		background-color: #fbfbfb;
	}
	
</style>